/**
 * @name: 账户信息相关接口
 * @description:
 * @author: Wood
 * @date: 2019/3/26
 * @update: 2019/4/24
 */
import axios from './rest-axios';

const getAccountInfo = () => axios.get('/manage/account/info');
const getAccountMemberNumber = () => axios.get('/manage/account/member_number');

const postAccountLogin = (login_name, password) => axios.post('/manage/account/login', {login_name, password});
const postChangePassword = (oldpassword, newpassword) => axios.post('/manage/account/changepassword', {
    oldpassword,
    newpassword
});

export {
    getAccountInfo,
    postAccountLogin,
    postChangePassword,
    getAccountMemberNumber,
};
